import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText, FDStack, FDTitleText } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const ModalInputSection = ({ value, label }) => {
  return (
    <FDStack direction={'column'} spacing={1} {...dataAttrs('model-input-section')}>
      <FDTitleText value={label} />
      <FDBodyText value={value} />
    </FDStack>
  );
};

ModalInputSection.defaultProps = {
  value: undefined,
  label: undefined,
};

ModalInputSection.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
};

export default ModalInputSection;
